export default __webpack_public_path__ + "static/media/product-image-21.c5caf4db.jpg";